import React, {Fragment, useEffect} from 'react';
import PropTypes from 'prop-types';
import BulkBlacklistGarageButton from './components/BulkBlacklistGarageButton';
import {useUnselectAll} from "react-admin";

const GarageBulkActionButtons = ({ selectedIds , resource }) => {

	const unselectAll = useUnselectAll();

	useEffect(() => { // to unselect all after component is unmounted

		return () => {
			// Anything in here is fired on component unmount.
			unselectAll(resource);

		}
	}, [unselectAll,resource])
	return(
	<Fragment>
	  <BulkBlacklistGarageButton id={selectedIds} />
	</Fragment>)
};

GarageBulkActionButtons.propTypes = {
	selectedIds: PropTypes.instanceOf(Array),
};

GarageBulkActionButtons.defaultProps = {
  selectedIds: [],
};

export default GarageBulkActionButtons;
